<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-personal-kanban`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 7h36a2 2 0 012 2v30a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2zm2 4v26h32V11H8zm17 13a1 1 0 011 1v7a1 1 0 01-1 1h-3a1 1 0 01-1-1v-7a1 1 0 011-1h3zm9-6a1 1 0 011 1v13a1 1 0 01-1 1h-3a1 1 0 01-1-1V19a1 1 0 011-1h3zm-17-7v8a1 1 0 01-1 1H8v-9h9z"/></svg>
</template>
<script>

export default {
  name: 'IconPersonalKanban',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
